import Moment from "moment";

Moment.locale("nb");

export default Moment;
